// Import-free and exported from the package on purpose (`exports` in
// package.json): the e2e proof and the Firefox nightly probe import this same
// function, so what they check is by construction what the app sends.

/**
 * The capture URL with its trailing slash removed: `…/i/v0/e/` → `…/i/v0/e`
 * (and the legacy `…/e/` → `…/e`), query string preserved. Every other SDK
 * request (`/flags/`, `/s/` replay uploads, config, logs) is returned as is.
 *
 * uBlock Origin's default "uBlock filters – Privacy" list blocks any request
 * matching `/e/*^ip=*^compression=` on any host, our own proxy included, and
 * several evaluators run it: for them every capture failed while the flags
 * request succeeded, so their whole desktop sessions vanished from analytics.
 * The rule needs the literal `/e/`; PostHog serves the slash-less path
 * identically (verified for gzip, JSON and beacon bodies). This keeps gzip
 * on, unlike turning compression off, so replay uploads stay small.
 */
export function withoutCaptureTrailingSlash(url: string): string {
  return url.replace(/\/e\/(?=\?|$)/, "/e");
}
